export const pricing_features_package_relations = {
  visitors: {
    community: {
      type: 'text',
      value: 'Unlimited',
    },
    starter: {
      type: 'text',
      value: 'Unlimited',
    },
    growth: {
      type: 'text',
      value: 'Unlimited',
    },
    scale: {
      type: 'text',
      value: 'Unlimited',
    },
  },
  internal_users: {
    community: {
      type: 'text',
      value: 'Unlimited',
    },
    starter: {
      type: 'text',
      value: 'Unlimited',
    },
    growth: {
      type: 'text',
      value: 'Unlimited',
    },
    scale: {
      type: 'text',
      value: 'Unlimited',
    },
  },
  external_users: {
    community: {
      type: 'number',
      value: 2500,
    },
    starter: {
      type: 'number',
      value: 15000,
    },
    growth: {
      type: 'number',
      value: 150000,
    },
    scale: {
      type: 'number',
      value: 300000,
    },
  },
  accounts: {
    community: {
      type: 'number',
      value: 1500,
    },
    starter: {
      type: 'number',
      value: 3000,
    },
    growth: {
      type: 'number',
      value: 30000,
    },
    scale: {
      type: 'number',
      value: 100000,
    },
  },
  listing: {
    community: {
      type: 'number',
      value: 1500,
    },
    starter: {
      type: 'number',
      value: 15000,
    },
    growth: {
      type: 'number',
      value: 100000,
    },
    scale: {
      type: 'number',
      value: 300000,
    },
  },
  stocks: {
    community: {
      type: 'boolean',
      value: true,
    },
    starter: {
      type: 'boolean',
      value: true,
    },
    growth: {
      type: 'boolean',
      value: true,
    },
    scale: {
      type: 'boolean',
      value: true,
    },
  },
  schedules: {
    community: {
      type: 'boolean',
      value: false,
    },
    starter: {
      type: 'boolean',
      value: true,
    },
    growth: {
      type: 'boolean',
      value: true,
    },
    scale: {
      type: 'boolean',
      value: true,
    },
  },
  simple_variant: {
    community: {
      type: 'boolean',
      value: false,
    },
    starter: {
      type: 'boolean',
      value: true,
    },
    growth: {
      type: 'boolean',
      value: true,
    },
    scale: {
      type: 'boolean',
      value: true,
    },
  },
  variant_matrix: {
    community: {
      type: 'boolean',
      value: false,
    },
    starter: {
      type: 'boolean',
      value: false,
    },
    growth: {
      type: 'boolean',
      value: true,
    },
    scale: {
      type: 'boolean',
      value: true,
    },
  },
  pricing_options: {
    community: {
      type: 'boolean',
      value: false,
    },
    starter: {
      type: 'boolean',
      value: false,
    },
    growth: {
      type: 'boolean',
      value: true,
    },
    scale: {
      type: 'boolean',
      value: true,
    },
  },
  social_engagements: {
    community: {
      type: 'boolean',
      value: true,
    },
    starter: {
      type: 'boolean',
      value: true,
    },
    growth: {
      type: 'boolean',
      value: true,
    },
    scale: {
      type: 'boolean',
      value: true,
    },
  },
  social_login: {
    community: {
      type: 'boolean',
      value: false,
    },
    starter: {
      type: 'boolean',
      value: false,
    },
    growth: {
      type: 'boolean',
      value: true,
    },
    scale: {
      type: 'boolean',
      value: true,
    },
  },
  single_signon: {
    community: {
      type: 'boolean',
      value: false,
    },
    starter: {
      type: 'boolean',
      value: false,
    },
    growth: {
      type: 'boolean',
      value: false,
    },
    scale: {
      type: 'boolean',
      value: true,
    },
  },
  quality_systems: {
    community: {
      type: 'boolean',
      value: true,
    },
    starter: {
      type: 'boolean',
      value: true,
    },
    growth: {
      type: 'boolean',
      value: true,
    },
    scale: {
      type: 'boolean',
      value: true,
    },
  },
  multi_languages_multi_currencies: {
    community: {
      type: 'boolean',
      value: false,
    },
    starter: {
      type: 'boolean',
      value: false,
    },
    growth: {
      type: 'boolean',
      value: true,
    },
    scale: {
      type: 'boolean',
      value: true,
    },
  },
  search_engine_indexing: {
    community: {
      type: 'text',
      value: 'Basic',
    },
    starter: {
      type: 'text',
      value: 'Advanced',
    },
    growth: {
      type: 'text',
      value: 'Advanced',
    },
    scale: {
      type: 'text',
      value: 'Advanced',
    },
  },
  custom_fields: {
    community: {
      type: 'boolean',
      value: true,
    },
    starter: {
      type: 'boolean',
      value: true,
    },
    growth: {
      type: 'boolean',
      value: true,
    },
    scale: {
      type: 'boolean',
      value: true,
    },
  },
  collection: {
    community: {
      type: 'boolean',
      value: true,
    },
    starter: {
      type: 'boolean',
      value: true,
    },
    growth: {
      type: 'boolean',
      value: true,
    },
    scale: {
      type: 'boolean',
      value: true,
    },
  },
  geolocation: {
    community: {
      type: 'boolean',
      value: true,
    },
    starter: {
      type: 'boolean',
      value: true,
    },
    growth: {
      type: 'boolean',
      value: true,
    },
    scale: {
      type: 'boolean',
      value: true,
    },
  },
  bulk_operations: {
    community: {
      type: 'boolean',
      value: false,
    },
    starter: {
      type: 'boolean',
      value: true,
    },
    growth: {
      type: 'boolean',
      value: true,
    },
    scale: {
      type: 'boolean',
      value: true,
    },
  },
  storage_limit: {
    community: {
      type: 'text',
      value: '500MB',
    },
    starter: {
      type: 'text',
      value: '50GB',
    },
    growth: {
      type: 'text',
      value: '1TB',
    },
    scale: {
      type: 'text',
      value: '5TB',
    },
  },
  layers_advanced_cms: {
    community: {
      type: 'text',
      value: 'Yes',
    },
    starter: {
      type: 'text',
      value: 'Yes',
    },
    growth: {
      type: 'text',
      value: 'Yes',
    },
    scale: {
      type: 'text',
      value: 'Yes',
    },
  },
  website_templates: {
    community: {
      type: 'text',
      value: '20+ Free',
    },
    starter: {
      type: 'text',
      value: '30+',
    },
    growth: {
      type: 'text',
      value: '30+',
    },
    scale: {
      type: 'text',
      value: '30+',
    },
  },
  page_history: {
    community: {
      type: 'text',
      value: '3 Days',
    },
    starter: {
      type: 'text',
      value: '30 Days',
    },
    growth: {
      type: 'text',
      value: '90 Days',
    },
    scale: {
      type: 'text',
      value: '1 Year',
    },
  },
  integrations: {
    community: {
      type: 'text',
      value: '20+ Free',
    },
    starter: {
      type: 'text',
      value: '25+',
    },
    growth: {
      type: 'text',
      value: '25+',
    },
    scale: {
      type: 'text',
      value: '25+',
    },
  },
  css_level_edit: {
    community: {
      type: 'boolean',
      value: true,
    },
    starter: {
      type: 'boolean',
      value: true,
    },
    growth: {
      type: 'boolean',
      value: true,
    },
    scale: {
      type: 'boolean',
      value: true,
    },
  },
  custom_code_injection: {
    community: {
      type: 'boolean',
      value: false,
    },
    starter: {
      type: 'boolean',
      value: false,
    },
    growth: {
      type: 'boolean',
      value: true,
    },
    scale: {
      type: 'boolean',
      value: true,
    },
  },
  advanced: {
    community: {
      type: 'boolean',
      value: true,
    },
    starter: {
      type: 'boolean',
      value: true,
    },
    growth: {
      type: 'boolean',
      value: true,
    },
    scale: {
      type: 'boolean',
      value: true,
    },
  },
  basic_rules: {
    community: {
      type: 'boolean',
      value: true,
    },
    starter: {
      type: 'boolean',
      value: true,
    },
    growth: {
      type: 'boolean',
      value: true,
    },
    scale: {
      type: 'boolean',
      value: true,
    },
  },
  advanced_rules: {
    community: {
      type: 'text',
      value: '-',
    },
    starter: {
      type: 'text',
      value: '-',
    },
    growth: {
      type: 'text',
      value: 'Coming Soon',
    },
    scale: {
      type: 'text',
      value: 'Coming Soon',
    },
  },
  shipping_logics: {
    community: {
      type: 'boolean',
      value: true,
    },
    starter: {
      type: 'boolean',
      value: true,
    },
    growth: {
      type: 'boolean',
      value: true,
    },
    scale: {
      type: 'boolean',
      value: true,
    },
  },
  custom_logics: {
    community: {
      type: 'boolean',
      value: true,
    },
    starter: {
      type: 'boolean',
      value: true,
    },
    growth: {
      type: 'boolean',
      value: true,
    },
    scale: {
      type: 'boolean',
      value: true,
    },
  },
  fulfillment_by_platform: {
    community: {
      type: 'boolean',
      value: false,
    },
    starter: {
      type: 'boolean',
      value: false,
    },
    growth: {
      type: 'boolean',
      value: true,
    },
    scale: {
      type: 'boolean',
      value: true,
    },
  },
  cart_based_ordering: {
    community: {
      type: 'boolean',
      value: true,
    },
    starter: {
      type: 'boolean',
      value: true,
    },
    growth: {
      type: 'boolean',
      value: true,
    },
    scale: {
      type: 'boolean',
      value: true,
    },
  },
  direct_booking_order: {
    community: {
      type: 'boolean',
      value: true,
    },
    starter: {
      type: 'boolean',
      value: true,
    },
    growth: {
      type: 'boolean',
      value: true,
    },
    scale: {
      type: 'boolean',
      value: true,
    },
  },
  negotiation_offer_price: {
    community: {
      type: 'boolean',
      value: false,
    },
    starter: {
      type: 'boolean',
      value: true,
    },
    growth: {
      type: 'boolean',
      value: true,
    },
    scale: {
      type: 'boolean',
      value: true,
    },
  },
  order_status_workflow: {
    community: {
      type: 'boolean',
      value: true,
    },
    starter: {
      type: 'boolean',
      value: true,
    },
    growth: {
      type: 'boolean',
      value: true,
    },
    scale: {
      type: 'boolean',
      value: true,
    },
  },
  order_status_flow_persistent_messages: {
    community: {
      type: 'boolean',
      value: true,
    },
    starter: {
      type: 'boolean',
      value: true,
    },
    growth: {
      type: 'boolean',
      value: true,
    },
    scale: {
      type: 'boolean',
      value: true,
    },
  },
  transaction_split: {
    community: {
      type: 'boolean',
      value: true,
    },
    starter: {
      type: 'boolean',
      value: true,
    },
    growth: {
      type: 'boolean',
      value: true,
    },
    scale: {
      type: 'boolean',
      value: true,
    },
  },
  other_order_logics: {
    community: {
      type: 'boolean',
      value: true,
    },
    starter: {
      type: 'boolean',
      value: true,
    },
    growth: {
      type: 'boolean',
      value: true,
    },
    scale: {
      type: 'boolean',
      value: true,
    },
  },
  gated_subscription_on_platform: {
    community: {
      type: 'boolean',
      value: false,
    },
    starter: {
      type: 'boolean',
      value: false,
    },
    growth: {
      type: 'boolean',
      value: true,
    },
    scale: {
      type: 'boolean',
      value: true,
    },
  },
  special_fees: {
    community: {
      type: 'boolean',
      value: true,
    },
    starter: {
      type: 'boolean',
      value: true,
    },
    growth: {
      type: 'boolean',
      value: true,
    },
    scale: {
      type: 'boolean',
      value: true,
    },
  },
  commission_deduction: {
    community: {
      type: 'boolean',
      value: true,
    },
    starter: {
      type: 'boolean',
      value: true,
    },
    growth: {
      type: 'boolean',
      value: true,
    },
    scale: {
      type: 'boolean',
      value: true,
    },
  },
  subscription_on_listing: {
    community: {
      type: 'boolean',
      value: false,
    },
    starter: {
      type: 'boolean',
      value: false,
    },
    growth: {
      type: 'boolean',
      value: false,
    },
    scale: {
      type: 'boolean',
      value: true,
    },
  },
  webhooks: {
    community: {
      type: 'boolean',
      value: false,
    },
    starter: {
      type: 'boolean',
      value: false,
    },
    growth: {
      type: 'boolean',
      value: true,
    },
    scale: {
      type: 'boolean',
      value: true,
    },
  },
  headless_api_access: {
    community: {
      type: 'boolean',
      value: false,
    },
    starter: {
      type: 'boolean',
      value: false,
    },
    growth: {
      type: 'boolean',
      value: true,
    },
    scale: {
      type: 'boolean',
      value: true,
    },
  },
  api_rate_limit: {
    community: {
      type: 'text',
      value: '120 RPM',
    },
    starter: {
      type: 'text',
      value: '120 RPM',
    },
    growth: {
      type: 'text',
      value: '120 RPM',
    },
    scale: {
      type: 'text',
      value: 'Custom',
    },
  },
  open_source_apps_support: {
    community: {
      type: 'text',
      value: '-',
    },
    starter: {
      type: 'text',
      value: '-',
    },
    growth: {
      type: 'text',
      value: 'Community forum',
    },
    scale: {
      type: 'text',
      value: 'Community forum',
    },
  },
  api_reference_sdk_support: {
    community: {
      type: 'text',
      value: 'Community forum',
    },
    starter: {
      type: 'text',
      value: '+Email/Tickets',
    },
    growth: {
      type: 'text',
      value: 'Same',
    },
    scale: {
      type: 'text',
      value: 'Same',
    },
  },
  email_from_address: {
    community: {
      type: 'text',
      value: 'Tradly email',
    },
    starter: {
      type: 'text',
      value: 'Tradly email',
    },
    growth: {
      type: 'text',
      value: 'Your Domain',
    },
    scale: {
      type: 'text',
      value: 'Your Domain',
    },
  },
  customize_email_templates: {
    community: {
      type: 'text',
      value: '-',
    },
    starter: {
      type: 'text',
      value: 'Yes',
    },
    growth: {
      type: 'text',
      value: 'Yes',
    },
    scale: {
      type: 'text',
      value: 'Yes',
    },
  },
  in_app_chat: {
    community: {
      type: 'text',
      value: '-',
    },
    starter: {
      type: 'text',
      value: '-',
    },
    growth: {
      type: 'text',
      value: '-',
    },
    scale: {
      type: 'text',
      value: 'Yes',
    },
  },
  web_app_deployment: {
    community: {
      type: 'text',
      value: 'Yes',
    },
    starter: {
      type: 'text',
      value: 'Yes',
    },
    growth: {
      type: 'text',
      value: 'Yes',
    },
    scale: {
      type: 'text',
      value: 'Yes',
    },
  },
  ssl: {
    community: {
      type: 'text',
      value: 'Yes',
    },
    starter: {
      type: 'text',
      value: 'Yes',
    },
    growth: {
      type: 'text',
      value: 'Yes',
    },
    scale: {
      type: 'text',
      value: 'Yes',
    },
  },
  rbac: {
    community: {
      type: 'text',
      value: '-',
    },
    starter: {
      type: 'text',
      value: '-',
    },
    growth: {
      type: 'text',
      value: 'Yes',
    },
    scale: {
      type: 'text',
      value: 'Yes',
    },
  },
  sites: {
    community: {
      type: 'text',
      value: '2',
    },
    starter: {
      type: 'text',
      value: '3',
    },
    growth: {
      type: 'text',
      value: '5',
    },
    scale: {
      type: 'text',
      value: '20',
    },
  },
  custom_domain: {
    community: {
      type: 'text',
      value: 'Tradly.co free subdomain + Add your own domain',
    },
    starter: {
      type: 'text',
      value: 'Same',
    },
    growth: {
      type: 'text',
      value: 'Same',
    },
    scale: {
      type: 'text',
      value: 'Same',
    },
  },
  managed_support: {
    community: {
      type: 'text',
      value: '-',
    },
    starter: {
      type: 'text',
      value: '-',
    },
    growth: {
      type: 'text',
      value: '-',
    },
    scale: {
      type: 'text',
      value: 'Yes',
    },
  },
  stripe: {
    community: {
      type: 'boolean',
      value: true,
    },
    starter: {
      type: 'boolean',
      value: true,
    },
    growth: {
      type: 'boolean',
      value: true,
    },
    scale: {
      type: 'boolean',
      value: true,
    },
  },
  mangopay: {
    community: {
      type: 'boolean',
      value: false,
    },
    starter: {
      type: 'boolean',
      value: false,
    },
    growth: {
      type: 'boolean',
      value: true,
    },
    scale: {
      type: 'boolean',
      value: true,
    },
  },
  myfatoorah: {
    community: {
      type: 'boolean',
      value: false,
    },
    starter: {
      type: 'boolean',
      value: false,
    },
    growth: {
      type: 'boolean',
      value: true,
    },
    scale: {
      type: 'boolean',
      value: true,
    },
  },
  pawapay: {
    community: {
      type: 'boolean',
      value: true,
    },
    starter: {
      type: 'boolean',
      value: true,
    },
    growth: {
      type: 'boolean',
      value: true,
    },
    scale: {
      type: 'boolean',
      value: true,
    },
  },
  pawapay: {
    community: {
      type: 'boolean',
      value: true,
    },
    starter: {
      type: 'boolean',
      value: true,
    },
    growth: {
      type: 'boolean',
      value: true,
    },
    scale: {
      type: 'boolean',
      value: true,
    },
  },
  payu: {
    community: {
      type: 'boolean',
      value: false,
    },
    starter: {
      type: 'boolean',
      value: true,
    },
    growth: {
      type: 'boolean',
      value: true,
    },
    scale: {
      type: 'boolean',
      value: true,
    },
  },
  others: {
    community: {
      type: 'boolean',
      value: true,
    },
    starter: {
      type: 'boolean',
      value: true,
    },
    growth: {
      type: 'boolean',
      value: true,
    },
    scale: {
      type: 'boolean',
      value: true,
    },
  },
  cash_based: {
    community: {
      type: 'boolean',
      value: true,
    },
    starter: {
      type: 'boolean',
      value: true,
    },
    growth: {
      type: 'boolean',
      value: true,
    },
    scale: {
      type: 'boolean',
      value: true,
    },
  },
  additional_payments: {
    community: {
      type: 'boolean',
      value: false,
    },
    starter: {
      type: 'boolean',
      value: false,
    },
    growth: {
      type: 'boolean',
      value: true,
    },
    scale: {
      type: 'boolean',
      value: true,
    },
  },
  self_help: {
    community: {
      type: 'boolean',
      value: true,
    },
    starter: {
      type: 'boolean',
      value: true,
    },
    growth: {
      type: 'boolean',
      value: true,
    },
    scale: {
      type: 'boolean',
      value: true,
    },
  },
  email_support: {
    community: {
      type: 'boolean',
      value: true,
    },
    starter: {
      type: 'boolean',
      value: true,
    },
    growth: {
      type: 'boolean',
      value: true,
    },
    scale: {
      type: 'boolean',
      value: true,
    },
  },
  support_desk: {
    community: {
      type: 'boolean',
      value: false,
    },
    starter: {
      type: 'boolean',
      value: true,
    },
    growth: {
      type: 'boolean',
      value: true,
    },
    scale: {
      type: 'boolean',
      value: true,
    },
  },
  community_forum: {
    community: {
      type: 'boolean',
      value: true,
    },
    starter: {
      type: 'boolean',
      value: true,
    },
    growth: {
      type: 'boolean',
      value: true,
    },
    scale: {
      type: 'boolean',
      value: true,
    },
  },
  live_chat: {
    community: {
      type: 'boolean',
      value: false,
    },
    starter: {
      type: 'boolean',
      value: false,
    },
    growth: {
      type: 'boolean',
      value: true,
    },
    scale: {
      type: 'boolean',
      value: true,
    },
  },
  sales_call: {
    community: {
      type: 'text',
      value: '-',
    },
    starter: {
      type: 'text',
      value: 'One Free 1hr Call. Further charged/Hour & analysis charges',
    },
    growth: {
      type: 'text',
      value: 'same',
    },
    scale: {
      type: 'text',
      value: 'same',
    },
  },
  account_manager: {
    community: {
      type: 'boolean',
      value: false,
    },
    starter: {
      type: 'boolean',
      value: false,
    },
    growth: {
      type: 'boolean',
      value: false,
    },
    scale: {
      type: 'boolean',
      value: true,
    },
  },
  custom_development_services: {
    community: {
      type: 'boolean',
      value: false,
    },
    starter: {
      type: 'boolean',
      value: false,
    },
    growth: {
      type: 'boolean',
      value: true,
    },
    scale: {
      type: 'boolean',
      value: true,
    },
  },
  priority_desk: {
    community: {
      type: 'boolean',
      value: false,
    },
    starter: {
      type: 'boolean',
      value: false,
    },
    growth: {
      type: 'boolean',
      value: false,
    },
    scale: {
      type: 'boolean',
      value: true,
    },
  },
  

  
}
